import {
  ModelState,
  ModelActionTypes,
  SET_CURRENT_MODELS,
  GET_PAGINATED_MODELS_SUCCESS,
  GET_BUCKETS_SUCCESS,
  SET_EDIT_MODEL_LOADING,
} from "./types";

export const initialState: ModelState = {
  currentModels: [],
  editModelLoading: false,
  paginated: {},
  uuid: {},
  buckets: {},
  meta: null,
};

const reducer = (state = initialState, action: ModelActionTypes) => {
  
  switch (action.type) {
    case SET_CURRENT_MODELS: {
      const stateCopy: ModelState = JSON.parse(JSON.stringify(state));
      return {
        ...stateCopy,
        currentModels: action.payload,
      };
    }
    case SET_EDIT_MODEL_LOADING: {
      const stateCopy: ModelState = JSON.parse(JSON.stringify(state));
      return {
        ...stateCopy,
        editModelLoading: action.payload,
      };
    }
    case GET_PAGINATED_MODELS_SUCCESS: {
      const stateCopy: ModelState = JSON.parse(JSON.stringify(state));
      const { data, meta } = action.payload;
      const { currentPageNumber } = meta;
      if (Array.isArray(data)) {
        data.forEach((model) => (stateCopy.uuid[model.id] = model));
        stateCopy.meta = meta;
        stateCopy.paginated[currentPageNumber] = data;
      }
      return stateCopy;
    }
    case GET_BUCKETS_SUCCESS: {
      const stateCopy: ModelState = JSON.parse(JSON.stringify(state));
      const { data } = action.payload;
      stateCopy.buckets = data;
      return stateCopy;
    }
    default:
      return state;
  }
};

export default reducer;
